// @flow

import styled from 'styled-components';

const Input = styled.input.attrs({ type: 'checkbox' })`
  display: inline-block;
`;

export default Input;
